export const CARD_W = 280;
export const CARD_H = 350;
export const IMG_H = 190;
export const GAP = 12;
